import { makeStyles } from "@material-ui/core/styles";
import { Constants } from "../../../commons/Constants";
import { Transform } from "@material-ui/icons";

export const TyCStyles = makeStyles((theme) => ({
  mainContainer: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "4.5em",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "7.5em",
    },
    
  },
  cardContainer:{
    padding:"2em",
    alignItems: "center"
  },

  // margenes  para el menu lateral (en caso de haberlo)
  // container: {
  //   [theme.breakpoints.up("sm")]: {
  //     marginLeft: Constants.DrawerWidth,
  //   },    
  // },
  // hideContainer: {
  //   marginLeft: Constants.DrawerWidth,
  //   [theme.breakpoints.down("sm")]: {
  //     display: "none",
  //   },
  // },

  links: {
    color: "#333333",
    "&:hover": {
      textDecoration: "underline",
      color: "#333333",
    },
  },
  table: {
    border: "1px solid black",
    borderCollapse: "collapse",
    marginBottom: "1em",
  },
  text: {
    color: "#666666",
  },
  subtitles: {
    color: "#002453",
  },
  tableHead:{
    backgroundColor:"#666666",
  },
  tableHeadText:{
    color:"#FFFFFF"
  },

  title: {
    color: "#333333",
    textAlign: "center",
  },

  basicTitle: {
    color: "black"
  }
}));
